import type { Tournament } from '@/types';

/**
 * Tournaments whose name or league name contains `query` (trimmed,
 * case-insensitive) — the client mirror of the list endpoints' `search`
 * (ILIKE on tournament + league name). Order is kept; an empty query keeps all.
 */
export function filterTournamentsBySearch(items: Tournament[], query: string): Tournament[] {
  const needle = query.trim().toLocaleLowerCase();
  if (needle === '') return items;
  return items.filter((tournament) => (
    tournament.name.toLocaleLowerCase().includes(needle)
    || (tournament.leagueName?.toLocaleLowerCase().includes(needle) ?? false)
  ));
}
